import React from 'react';
import { unwrapModel } from '../../../../services/api/unwrapModel';
import { useInspectionDetailShareContext } from '../../../pages/upgrade/InspectionDetail/ShareInspection/InspectionDetailShareProvider';
import { useGetAllNotesByFindingForShareSuspense } from '../../../../services/api/generated/client';
import NotesWrapper from '../NotesWrapper';
const FindingNotesShareWrapper = (props) => {
    const { token } = useInspectionDetailShareContext();
    const { data: notesResponse } = useGetAllNotesByFindingForShareSuspense(token, props.model.id);
    const notes = unwrapModel(notesResponse);
    if (!notes) {
        return null;
    }
    return (React.createElement(NotesWrapper, { ...props, canEdit: false, type: "defect", notes: notes }));
};
export default FindingNotesShareWrapper;
